import * as React from 'react'
import cc from 'classcat'
import SelectButton from '../SelectButton'
import Expandable from '../Expandable'

import s from './styles.module.css'

const SelectableDropdown = ({
  options,
  selected,
  onSelect,
  collapseExpandable,
  dropdownOptionClassName
}) => (
  <Expandable
    className={s.dropdownWrapper}
    labelClassName={s.dropdownLabel}
    label={<span>{options[selected].title}</span>}
    render={({ collapse }) => (
      <div className={s.dropdown}>
        {options.map(({ title }, idx) => (
          <button
            key={idx}
            onClick={() => onSelect(idx)() && collapse()}
            selected={idx === selected}
            className={cc([s.dropdownOption, dropdownOptionClassName])}
          >
            {title}
          </button>
        ))}
      </div>
    )}
  />
)

export default class Selectable extends React.Component {
  state = { selected: 0 }

  onSelect = idx => () => {
    this.setState({ selected: idx })
  }

  render() {
    const {
      label,
      className,
      buttonClassName,
      buttonGroupClassName,
      selectedButtonClassName,
      dropdownOptionClassName,
      options,
      render,
      button,
      showOthers
    } = this.props

    const { selected } = this.state

    return (
      <div className={cc([s.wrapper, className])}>
        {label}
        <div className={cc([s.buttons, buttonGroupClassName])}>
          {options.map(({ title }, idx) => (
            <SelectButton
              key={idx}
              onClick={this.onSelect(idx)}
              selected={idx === selected}
              className={buttonClassName}
              selectedClassName={selectedButtonClassName}
            >
              {title}
            </SelectButton>
          ))}
        </div>
        <SelectableDropdown
          options={options}
          selected={selected}
          onSelect={this.onSelect}
          dropdownOptionClassName={dropdownOptionClassName}
        />
        {render({ ...options[this.state.selected] })}
        {showOthers ? options
          .filter((_, idx) => idx !== this.state.selected)
          .map(option => render({ ...option, isOther: true })) : null}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Selectable/index.js